import { render, staticRenderFns } from "./StatementOfIntentOfConversionToPartnership.vue?vue&type=template&id=6955b98a&scoped=true&"
import script from "./StatementOfIntentOfConversionToPartnership.vue?vue&type=script&lang=js&"
export * from "./StatementOfIntentOfConversionToPartnership.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6955b98a",
  null
  
)

export default component.exports